import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  { path: '*',
    name: 'OTHERS',
    redirect: '/404',
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/login',
    name: 'LOGIN',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/forgot_password',
    name: 'FORGOT_PASSWORD',
    component: () => import('@/views/login/forgot_password'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/verify_token',
    name: 'VERIFY_TOKEN',
    component: () => import('@/views/login/verify_token'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  {
    path: '/verify_social_oauth',
    name: 'VERIFY_SOCIAL_AUTH',
    component: () => import('@/views/login/verify_social_oauth'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  { path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
    meta: { group: 'DEFAULT' }
  },
  {
    path: '/policy',
    name: 'policy',
    component: Layout,
    redirect: '/user-policy',
    hidden: 'true',
    meta: { group: 'POLICY' },
    children: [{
      path: '/user-policy',
      name: 'user-policy',
      component: () => import('@/views/user-policy/index'),
      meta: { group: 'POLICY', icon: 'user-circle' }
    }]
  },
  {
    path: '/',
    name: 'dashboard',
    component: Layout,
    redirect: '/dashboard',
    hidden: 'true',
    meta: { group: 'QMS' },
    children: [{
      path: '/dashboard',
      name: 'qms',
      component: () => import('@/views/dashboard/index'),
      meta: { group: 'QMS', icon: 'user-circle' }
    }]
  },
  {
    path: '/table',
    name: 'table',
    component: Layout,
    redirect: '/qms',
    meta: { group: 'QMS' },
    hidden: true,
    children: [{
      name: 'table-view',
      path: ':name/:tableName',
      component: () => import('@/views/qms/table-view'),
      meta: { title: 'List Files', group: 'QMS', icon: 'tachometer-alt' }
    }]
  },
  {
    path: '/plan',
    component: Layout,
    redirect: 'folderList/index',
    meta: { group: 'QMS' },
    children: [{
      path: 'index',
      name: 'Plan',
      props: { category_id: 1 },
      component: () => import('@/views/qms/folderList'),
      meta: { title: 'Plan', group: 'QMS', icon: 'folder' }
    }]
  },
  {
    path: '/do',
    name: 'process',
    component: Layout,
    redirect: 'do-index',
    meta: { group: 'QMS' },
    children: [{
      path: 'index',
      name: 'Do',
      props: { category_id: 2 },
      component: () => import('@/views/qms/folderList'),
      meta: { title: 'Do', group: 'QMS', icon: 'folder' }
    }]
  },
  {
    path: '/check',
    component: Layout,
    meta: { group: 'QMS' },
    children: [{
      path: 'index',
      name: 'Check',
      props: { category_id: 3 },
      component: () => import('@/views/qms/folderList'),
      meta: { title: 'Check', group: 'QMS', icon: 'folder' }
    }]
  },
  {
    path: '/act',
    component: Layout,
    meta: { group: 'QMS' },
    children: [{
      path: 'index',
      name: 'Act',
      props: { category_id: 4 },
      component: () => import('@/views/qms/folderList'),
      meta: { title: 'Act', group: 'QMS', icon: 'folder' }
    }]
  },
  {
    path: '/profile',
    component: Layout,
    meta: { group: 'QMS' },
    children: [{
      path: '/profile',
      name: 'Profile',
      component: () => import('@/views/profile/index'),
      meta: { title: 'Account Settings', group: 'QMS', icon: 'user-circle' }
    }]
  },
  {
    path: '/setting',
    component: Layout,
    meta: { group: 'QMS_ADMIN' },
    children: [{
      path: 'index',
      name: 'Setting',
      component: () => import('@/views/qms/settings/index'),
      meta: { title: 'Settings', group: 'QMS_ADMIN', icon: 'cogs' }
    }]
  }
]

export default new Router({
  mode: 'history',
  hash: false,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
